import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import { PageHero, Icon, Button, PlaceCard, SectionHead } from '../../components/ui';

const SUGGESTIONS = [
  { icon: 'temple', title: 'Temples & Darshan', desc: 'Every temple and ghat, with timings', to: '/temples' },
  { icon: 'ticket', title: 'Darshan Booking', desc: 'Plan your visit to the Ram Mandir', to: '/darshan-booking' },
  { icon: 'compass', title: 'Travel Guide', desc: 'How to reach, stay and explore', to: '/travel-guide' },
  { icon: 'bed-double', title: 'Stay & Accommodation', desc: 'Verified stays near the Mandir', to: '/hotels' },
];

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <SEO
        title="404 — Page not found"
        description="This page does not exist on AyodhyaDham.info. Browse temples, darshan booking, the travel guide or places to stay."
        noindex
      />

      <PageHero
        crumbs={[{ label: t('Home'), to: '/' }, { label: t('Page not found') }]}
        title={t('This page has wandered off')}
        subtitle={t('We could not find that page. It may have moved, or the link may be mistyped.')}
      >
        <p className="small muted" style={{ marginTop: 4 }}>
          <Icon name="circle-alert" size={14} style={{ verticalAlign: 'text-bottom', marginRight: 6, color: 'var(--primary)' }} />
          <code>{location.pathname}</code>
        </p>
        <div className="hstack" style={{ gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
          <Button to="/" icon={<Icon name="home" size={16} />} iconPosition="left">{t('Go to home')}</Button>
          <Button variant="outline" to="/temples" icon={<Icon name="search" size={16} />} iconPosition="left">{t('Browse temples')}</Button>
        </div>
      </PageHero>

      <div className="container content-wrap">
        <SectionHead eyebrow={t('Try one of these')} title={t('Popular pages')} />
        <div className="card-grid">
          {SUGGESTIONS.map((s) => (
            <PlaceCard
              key={s.to}
              image="/images/design/ram-mandir-complex.webp"
              title={t(s.title)}
              subtitle={t(s.desc)}
              to={s.to}
              cta={t('Explore')}
            />
          ))}
        </div>
      </div>
    </>
  );
}
